import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { trace } from 'rytm-helpers';
import { updateLinks } from './linksFix';

const onCollapseShow = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelCollapse) {
    trigger.innerHTML = trigger.dataset.labelCollapse;
  }
}
const onCollapseShown = (e) => {
  scrollTriggerRefresh();
}
const onCollapseHide = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelExpand) {
    trigger.innerHTML = trigger.dataset.labelExpand;
  }
}
const onCollapseHiden = (e) => {
  scrollTriggerRefresh();
}
const getCollapseTrigger = (id) => {
  let trigger;
  if (id) {
    trigger = document.querySelector("a[href='#" + id + "']");
  }
  return trigger;
}
// ### Scroll Trigger update
export const scrollTriggerRefresh = () => {
  ScrollTrigger.refresh();
}
// ### Window update
export const windowUpdate = (e) => {
  updateLinks();
};
export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")];
  list.forEach((el) => {
    const parentDiv = el.parentNode;
    parentDiv.removeChild(el);
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv);
  })
}

// ### INIT
export const initCommon = () => {
  document.documentElement.addEventListener("show.bs.collapse", onCollapseShow);
  document.documentElement.addEventListener("shown.bs.collapse", onCollapseShown);
  document.documentElement.addEventListener("hide.bs.collapse", onCollapseHide);
  document.documentElement.addEventListener("hiden.bs.collapse", onCollapseHiden);
  window.addEventListener('resize', windowUpdate);
  document.addEventListener('DOMContentLoaded', windowUpdate);
  // window update
  windowUpdate();
};

